if (!customElements.get('smooche-gallery-settings')) {
  customElements.define('smooche-gallery-settings', class extends HTMLElement {
    connectedCallback() {
      const config = JSON.parse(this.querySelector('script').textContent);
      const sectionRoot = this.closest('.smooche-product');
      if (!sectionRoot) return;
      const owner = this;
      const controller = new AbortController();
      const cleanups = this.cleanups = [() => controller.abort()];
      const modalId = 'cs-choice-modal-' + config.sectionId;
      function listen(target, type, handler, options = {}) {
        target.addEventListener(type, handler, { ...options, signal: controller.signal });
      }
      function setTimeout(callback, delay) {
        const id = window.setTimeout(() => { if (owner.isConnected) callback(); }, delay);
        cleanups.push(() => window.clearTimeout(id));
        return id;
      }
      function setInterval(callback, delay) {
        const id = window.setInterval(callback, delay);
        cleanups.push(() => window.clearInterval(id));
        return id;
      }
      var BADGE_ENABLED = config.badgeEnabled;
      var BADGE_TITLE = config.badgeTitle;
      var BADGE_COUNT = config.badgeCount;
      var BADGE_BODY = config.badgeBody;
      var BADGE_CTA = config.badgeCta;
      var BADGE_CTA_URL = config.badgeUrl;
      var MODAL = config.modal;
    var LAUREL_L =
      '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="35" viewBox="0 0 17 35" fill="none" aria-hidden="true">' +
      '<path d="M2.60396 10.0782C2.63019 12.7275 5.0681 14.8472 5.0681 14.8472C5.0681 14.8472 7.46457 12.6717 7.43993 10.0222C7.41325 7.3697 4.97398 5.25178 4.97398 5.25178C4.97398 5.25178 2.57932 7.42863 2.60396 10.0782ZM1.34556 19.1722C2.78927 21.3977 5.99278 21.9007 5.99278 21.9007C5.99278 21.9007 6.85625 18.7951 5.41254 16.5696C3.96883 14.3441 0.763495 13.8397 0.763495 13.8397C0.763495 13.8397 -0.0997442 16.9469 1.34556 19.1722ZM3.82901 27.3622C6.16621 28.6381 9.23028 27.5709 9.23028 27.5709C9.23028 27.5709 8.50337 24.4335 6.16618 23.1576C3.82898 21.8817 0.764911 22.9489 0.764911 22.9489C0.764911 22.9489 1.49182 26.0862 3.82901 27.3622ZM10.5368 33.3638C13.0903 34.1327 15.868 32.4611 15.868 32.4611C15.868 32.4611 14.504 29.5425 11.9502 28.772C9.39665 28.0031 6.62082 29.6761 6.62082 29.6761C6.62082 29.6761 7.98323 32.5949 10.5368 33.3638ZM9.02056 3.29033C7.3448 5.35644 7.8659 8.53241 7.8659 8.53241C7.8659 8.53241 11.1079 8.36114 12.7836 6.29503C14.4594 4.22891 13.9381 1.05136 13.9381 1.05136C13.9381 1.05136 10.6963 1.22421 9.02056 3.29033Z" stroke="#212121" stroke-linecap="round"/>' +
      '</svg>';
    var LAUREL_R =
      '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="35" viewBox="0 0 17 35" fill="none" aria-hidden="true">' +
      '<path d="M14.1756 10.0782C14.1494 12.7275 11.7114 14.8472 11.7114 14.8472C11.7114 14.8472 9.31497 12.6717 9.33961 10.0222C9.36629 7.3697 11.8056 5.25178 11.8056 5.25178C11.8056 5.25178 14.2002 7.42863 14.1756 10.0782ZM15.434 19.1722C13.9903 21.3977 10.7868 21.9007 10.7868 21.9007C10.7868 21.9007 9.92329 18.7951 11.367 16.5696C12.8107 14.3441 16.016 13.8397 16.016 13.8397C16.016 13.8397 16.8793 16.9469 15.434 19.1722ZM12.9505 27.3622C10.6133 28.6381 7.54926 27.5709 7.54926 27.5709C7.54926 27.5709 8.27617 24.4335 10.6134 23.1576C12.9506 21.8817 16.0146 22.9489 16.0146 22.9489C16.0146 22.9489 15.2877 26.0862 12.9505 27.3622ZM6.24277 33.3638C3.68923 34.1327 0.911591 32.4611 0.911591 32.4611C0.911591 32.4611 2.27559 29.5425 4.82935 28.772C7.38289 28.0031 10.1587 29.6761 10.1587 29.6761C10.1587 29.6761 8.79631 32.5949 6.24277 33.3638ZM7.75898 3.29033C9.43474 5.35644 8.91365 8.53241 8.91365 8.53241C8.91365 8.53241 5.67166 8.36114 3.9959 6.29503C2.32014 4.22891 2.84146 1.05136 2.84146 1.05136C2.84146 1.05136 6.08322 1.22421 7.75898 3.29033Z" stroke="#212121" stroke-linecap="round"/>' +
      '</svg>';

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function titleHtml(title) {
      var parts = String(title || '').trim().split(/\s+/);
      if (parts.length <= 1) return escapeHtml(title);
      return escapeHtml(parts[0]) + '<br>' + escapeHtml(parts.slice(1).join(' '));
    }

    function badgeBodyHtml() {
      var body = String(BADGE_BODY || '').trim();
      var message = document.createElement('div');
      message.innerHTML = body;
      var paragraph = message.querySelector('p');
      if (!paragraph) {
        paragraph = document.createElement('p');
        message.prepend(paragraph);
      }
      if (BADGE_COUNT) {
        paragraph.insertAdjacentHTML('afterbegin', '<span class="cs-choice-badge__bold">' + escapeHtml(BADGE_COUNT) + '</span> ');
      }
      return message.innerHTML;
    }

    function openChoiceModal() {
      var screen = ensureChoiceModal();
      screen.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeChoiceModal() {
      var screen = document.getElementById(modalId);
      if (!screen) return;
      screen.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    function faqToggleHtml() {
      return (
        '<span class="cs-choice-modal__faq-toggle cs-choice-modal__plus" aria-hidden="true"><svg viewBox="0 0 17 18" fill="none"><path d="M0 9h17M8.5.5v17" stroke="#212121" stroke-width="3"/></svg></span>' +
        '<span class="cs-choice-modal__faq-toggle cs-choice-modal__minus" aria-hidden="true"><svg viewBox="0 0 10 2" fill="none"><path d="M0 0h10v2H0z" fill="#212121"/></svg></span>'
      );
    }

    function reviewLinkIcon() {
      return '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M5.6 1.5H2.9A1.4 1.4 0 0 0 1.5 2.9v8.2A1.4 1.4 0 0 0 2.9 12.5h8.2a1.4 1.4 0 0 0 1.4-1.4V8.4M7 7l5.5-5.5M12.5 1.5V4.9M12.5 1.5H9.1" stroke="#212121" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/></svg>';
    }

    function ensureChoiceModal() {
      var existing = document.getElementById(modalId);
      if (existing) return existing;

      var reviewsHref = BADGE_CTA_URL || '#looxReviews';
      var screen = document.createElement('div');
      screen.id = modalId;
      screen.className = 'cs-choice-modal-screen';
      screen.setAttribute('role', 'dialog');
      screen.setAttribute('aria-modal', 'true');
      screen.setAttribute('aria-label', (MODAL.headerLogoAlt || BADGE_TITLE) + ' details');

      var faqsHtml = '';
      (MODAL.faqs || []).forEach(function (faq) {
        if (!faq || !faq.q) return;
        faqsHtml +=
          '<details class="cs-choice-modal__faq">' +
            '<summary>' + escapeHtml(faq.q) + faqToggleHtml() + '</summary>' +
            '<div class="cs-choice-modal__faq-answer">' + (faq.a || '') + '</div>' +
          '</details>';
      });

      var introHtml = MODAL.peopleIntro || '';
      if (introHtml && introHtml.indexOf('<a') === -1 && introHtml.indexOf('click here') !== -1) {
        introHtml = introHtml.replace(
          /click here/i,
          '<a href="' + escapeHtml(reviewsHref) + '">click here</a>'
        );
      }

      var peopleHtml = '';
      (MODAL.people || []).forEach(function (person) {
        if (!person || (!person.name && !person.img)) return;
        peopleHtml +=
          '<div class="cs-choice-modal__person">' +
            '<div class="cs-choice-modal__person-main">' +
              (person.img
                ? '<img src="' + escapeHtml(person.img) + '" alt="' + escapeHtml(person.name || '') + '">'
                : '') +
              '<div><strong>' + escapeHtml(person.name || '') + '</strong><span>' +
                escapeHtml(person.sub || '') + '</span></div>' +
            '</div>' +
            '<a class="cs-choice-modal__preview" href="' + escapeHtml(reviewsHref) + '">' + escapeHtml(MODAL.previewLabel || '') + ' ' +
              reviewLinkIcon() + '</a>' +
          '</div>';
      });

      screen.innerHTML =
        '<div class="cs-choice-modal">' +
          '<div class="cs-choice-modal__header">' +
            '<button type="button" class="cs-choice-modal__icon-btn cs-choice-modal__back" aria-label="Close">' +
              '<svg width="10" height="16" viewBox="0 0 10 16" fill="none" aria-hidden="true"><path d="M8.5 1 1.5 8l7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</button>' +
            '<div class="cs-choice-modal__brand">' +
              '<img src="' + escapeHtml(MODAL.headerLogo) + '" alt="' + escapeHtml(MODAL.headerLogoAlt) +
                '" width="' + escapeHtml(MODAL.headerLogoWidth) + '" height="' + escapeHtml(MODAL.headerLogoHeight) + '">' +
            '</div>' +
            '<button type="button" class="cs-choice-modal__icon-btn cs-choice-modal__close" aria-label="Close">' +
              '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1 11 11 1M1 1l10 10" stroke="currentColor" stroke-width="2"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="cs-choice-modal__body">' +
            '<div class="cs-choice-modal__faqs">' + faqsHtml + '</div>' +
            (MODAL.showReviews !== false
              ? '<div class="cs-choice-modal__people">' +
                  (MODAL.peopleHeading ? '<h3>' + escapeHtml(MODAL.peopleHeading) + '</h3>' : '') +
                  (introHtml ? '<div class="cs-choice-modal__people-intro rte">' + introHtml + '</div>' : '') +
                  peopleHtml +
                  (MODAL.disclaimer
                    ? '<p class="cs-choice-modal__disclaimer">' + escapeHtml(MODAL.disclaimer) + '</p>'
                    : '') +
                '</div>' +
                '<div class="cs-choice-modal__footer">' +
                  '<a href="' + escapeHtml(reviewsHref) + '">' +
                    escapeHtml(MODAL.footerLabel || '') +
                  '</a>' +
                '</div>'
              : '') +
          '</div>' +
        '</div>';

      document.body.appendChild(screen);
      cleanups.push(function() { if (screen.classList.contains('is-open')) closeChoiceModal(); screen.remove(); });

      listen(screen, 'click', function (e) {
        if (e.target === screen) closeChoiceModal();
      });
      screen.querySelectorAll('.cs-choice-modal__back, .cs-choice-modal__close').forEach(function (btn) {
        listen(btn, 'click', function (e) {
          e.preventDefault();
          closeChoiceModal();
        });
      });
      listen(document, 'keydown', function (e) {
        if (e.key === 'Escape') closeChoiceModal();
      });

      return screen;
    }

    function getGallery() {
      return sectionRoot.querySelector('media-gallery');
    }

    function getHost(gallery) {
      return (
        gallery.closest('.product__media-gallery') ||
        gallery.closest('.product__media-wrapper') ||
        gallery
      );
    }

    function mediaItems(gallery) {
      return Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));
    }

    function thumbItems(gallery) {
      return Array.prototype.slice.call(
        gallery.querySelectorAll('.thumbnail-list__item[data-target], [id^="GalleryThumbnails"] [data-target]')
      );
    }

    function activeIndex(gallery) {
      var items = mediaItems(gallery);
      var idx = items.findIndex(function (el) {
        return el.classList.contains('is-active');
      });
      if (idx >= 0) return idx;
      /* thumbnail_slider may keep first visible without is-active briefly */
      var aria = gallery.querySelector('.thumbnail[aria-current="true"]');
      if (aria) {
        var li = aria.closest('[data-target]');
        if (li) {
          return items.findIndex(function (el) {
            return el.dataset.mediaId === li.dataset.target;
          });
        }
      }
      return 0;
    }

    function goTo(gallery, dir) {
      var items = mediaItems(gallery);
      if (!items.length) return;
      var next = (activeIndex(gallery) + dir + items.length) % items.length;
      var mediaId = items[next] && items[next].dataset.mediaId;
      if (!mediaId) return;

      if (typeof gallery.setActiveMedia === 'function') {
        try {
          gallery.setActiveMedia(mediaId, false);
        } catch (err) {
          var thumb = gallery.querySelector(
            '[data-target="' + mediaId + '"] button, [data-target="' + mediaId + '"] .thumbnail'
          );
          if (thumb) thumb.click();
        }
      } else {
        var thumbBtn = gallery.querySelector(
          '[data-target="' + mediaId + '"] button, [data-target="' + mediaId + '"] .thumbnail'
        );
        if (thumbBtn) thumbBtn.click();
      }

      /* slideChanged is scroll-based and can miss class-only switches */
      var host = getHost(gallery);
      var stage = host.querySelector('.cs-gallery-layer__stage');
      requestAnimationFrame(function () {
        syncStage(stage, gallery);
        updateBadgeVisibility(gallery);
      });
    }

    function syncStage(stage, gallery) {
      if (!stage) return;
      var active =
        gallery.querySelector('.product__media-item.is-active') ||
        gallery.querySelector('.product__media-item');
      if (!active) return;
      var media = active.querySelector('.product__media, .media, .product-media-container') || active;
      var host = getHost(gallery);
      var hostBox = host.getBoundingClientRect();
      var box = media.getBoundingClientRect();
      stage.style.top = Math.max(0, box.top - hostBox.top) + 'px';
      stage.style.left = Math.max(0, box.left - hostBox.left) + 'px';
      stage.style.width = box.width + 'px';
      stage.style.setProperty('--cs-gallery-width', box.width + 'px');
      stage.style.setProperty('--cs-badge-fit-scale', Math.min(1.1, box.width / 460));
      stage.style.height = box.height + 'px';
    }

    function ensureLayer(gallery) {
      var host = getHost(gallery);
      var layer = host.querySelector('.cs-gallery-layer');
      if (layer) return layer;

      layer = document.createElement('div');
      layer.className = 'cs-gallery-layer';
      layer.setAttribute('data-cs-gallery-layer', '');

      var stage = document.createElement('div');
      stage.className = 'cs-gallery-layer__stage';

      var arrows = document.createElement('div');
      arrows.className = 'cs-gallery-arrows';
      arrows.innerHTML =
        '<button type="button" class="cs-gallery-arrows__btn cs-gallery-arrows__btn--prev" aria-label="Previous image">' +
        '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 7.5 10 12.5 15 7.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<button type="button" class="cs-gallery-arrows__btn cs-gallery-arrows__btn--next" aria-label="Next image">' +
        '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 7.5 10 12.5 15 7.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';

      listen(arrows.querySelector('.cs-gallery-arrows__btn--prev'), 'click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(gallery, -1);
      });
      listen(arrows.querySelector('.cs-gallery-arrows__btn--next'), 'click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(gallery, 1);
      });

      stage.appendChild(arrows);

      if (BADGE_ENABLED) {
        var badge = document.createElement('div');
        badge.className = 'cs-choice-badge is-visible';
        badge.setAttribute('data-cs-choice-badge', '');
        badge.setAttribute('data-state', 'max');
        badge.innerHTML =
          '<div class="cs-choice-badge__panel">' +
            '<div class="cs-choice-badge__ribbons" aria-hidden="true">' +
              '<span class="cs-choice-badge__ribbon-body"></span>' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="55" viewBox="0 0 35 55" fill="none">' +
                '<path d="M6.22738 53.1828C4.70359 55.8577 0.620657 54.7763 0.620658 51.6978L0.620659 3.04114C0.620659 1.38431 1.96378 0.0411848 3.62061 0.0411847L31.3383 0.0411841C33.64 0.0411841 35.0843 2.5262 33.9451 4.52615L6.22738 53.1828Z" fill="#ffffff"/>' +
              '</svg>' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="55" viewBox="0 0 35 55" fill="none">' +
                '<path d="M6.42748 1.98895C4.91635 -0.705341 0.810919 0.367404 0.810919 3.45655L0.810917 51.9593C0.810917 53.6162 2.15404 54.9593 3.81087 54.9593L31.0144 54.9593C33.3072 54.9593 34.7526 52.4915 33.631 50.4917L6.42748 1.98895Z" fill="#ffffff"/>' +
              '</svg>' +
            '</div>' +
            '<div class="cs-choice-badge__max">' +
              '<div class="cs-choice-badge__shell">' +
                '<div class="cs-choice-badge__heading">' +
                  '<span>' + LAUREL_L + '</span>' +
                  '<p>' + titleHtml(BADGE_TITLE) + '</p>' +
                  '<span>' + LAUREL_R + '</span>' +
                '</div>' +
                '<div class="cs-choice-badge__column">' +
                  '<div class="cs-choice-badge__message">' + badgeBodyHtml() + '</div>' +
                  '<div class="cs-choice-badge__cta">' +
                    '<span class="cs-choice-badge__avatars" aria-hidden="true">' +
                      (config.badgeAvatars || []).filter(Boolean).map(function(url) { return '<img src="' + escapeHtml(url) + '" alt="">'; }).join('') +
                    '</span>' +
                    '<button type="button" class="cs-choice-badge__learn" aria-label="' + escapeHtml(BADGE_CTA) + '">' +
                      '<p>' + escapeHtml(BADGE_CTA) + '</p>' +
                    '</button>' +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<button type="button" class="cs-choice-badge__close" aria-label="Minimize badge">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none" aria-hidden="true">' +
                  '<path d="M1 5.5L0.5 5L2.5 3L0.5 1L1 0.5L3 2.5L5 0.5L5.5 1L3.5 3L5.5 5L5 5.5L3 3.5L1 5.5Z" fill="#212121"/>' +
                '</svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="cs-choice-badge__min-btn" aria-label="Expand badge">' +
            '<span class="cs-choice-badge__min-shape" aria-hidden="true"></span>' +
          '</button>';

        function setBadgeState(next) {
          badge.setAttribute('data-state', next);
        }

        listen(badge.querySelector('.cs-choice-badge__close'), 'click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          setBadgeState('min');
        });
        listen(badge.querySelector('.cs-choice-badge__min-btn'), 'click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          setBadgeState('max');
        });
        listen(badge.querySelector('.cs-choice-badge__learn'), 'click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openChoiceModal();
        });
        listen(badge.querySelector('.cs-choice-badge__column'), 'click', function (e) {
          if (e.target.closest('.cs-choice-badge__learn, a')) return;
          e.preventDefault();
          e.stopPropagation();
          openChoiceModal();
        });

        stage.appendChild(badge);
      }

      layer.appendChild(stage);
      host.appendChild(layer);
      cleanups.push(function() { layer.remove(); delete gallery.dataset.csGalleryBound; });
      return layer;
    }

    function updateBadgeVisibility(gallery) {
      var badge = getHost(gallery).querySelector('[data-cs-choice-badge]');
      if (!badge) return;
      var items = mediaItems(gallery);
      var idx = activeIndex(gallery);
      var firstId = items[0] && items[0].dataset.mediaId;
      var active = items[idx];
      var onFirst = !active || !firstId || active.dataset.mediaId === firstId || idx === 0;
      badge.classList.toggle('is-visible', onFirst);
    }

    function killViewerPadding(gallery) {
      var viewer = gallery.querySelector('slider-component');
      if (!viewer) return;
      viewer.style.paddingLeft = '0';
      viewer.style.paddingRight = '0';
      viewer.style.maxWidth = '100%';
      viewer.style.width = '100%';
    }

    function mount() {
      var gallery = getGallery();
      if (!gallery) return;

      killViewerPadding(gallery);
      var layer = ensureLayer(gallery);
      var stage = layer.querySelector('.cs-gallery-layer__stage');
      syncStage(stage, gallery);
      updateBadgeVisibility(gallery);

      if (gallery.dataset.csGalleryBound === '1') return;
      gallery.dataset.csGalleryBound = '1';

      var viewer = gallery.querySelector('slider-component');
      if (viewer) {
        listen(viewer, 'slideChanged', function () {
          syncStage(stage, gallery);
          updateBadgeVisibility(gallery);
        });
      }

      var thumbsRoot = gallery.querySelector('[id^="GalleryThumbnails"]') || gallery;
      listen(thumbsRoot, 'click', function (e) {
        if (!e.target.closest('[data-target], .thumbnail')) return;
        setTimeout(function () {
          syncStage(stage, gallery);
          updateBadgeVisibility(gallery);
        }, 0);
      });

      var list = gallery.querySelector('.product__media-list');
      if (list && typeof MutationObserver !== 'undefined') {
        var mo = new MutationObserver(function () {
          syncStage(stage, gallery);
          updateBadgeVisibility(gallery);
          /* If theme wiped our layer somehow, remount */
          if (!getHost(gallery).querySelector('.cs-gallery-layer')) {
            delete gallery.dataset.csGalleryBound;
            mount();
          }
        });
        cleanups.push(function() { mo.disconnect(); });
        mo.observe(list, { attributes: true, childList: true, subtree: true, attributeFilter: ['class'] });
      }

      listen(window, 'resize', function () {
        syncStage(stage, gallery);
      });

      listen(window, 
        'scroll',
        function () {
          syncStage(stage, gallery);
        },
        { passive: true }
      );

      /* Re-sync after images / sticky layout settle */
      [50, 250, 800, 1600].forEach(function (ms) {
        setTimeout(function () {
          syncStage(stage, gallery);
          updateBadgeVisibility(gallery);
        }, ms);
      });
    }

    function boot() {
      mount();
      /* Gallery can appear late in theme editor / deferred media */
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        var g = getGallery();
        if (g && !getHost(g).querySelector('.cs-gallery-layer')) {
          delete g.dataset.csGalleryBound;
          mount();
        }
        if (tries >= 20 || (g && getHost(g).querySelector('.cs-gallery-layer'))) {
          clearInterval(timer);
        }
      }, 300);
    }

    if (document.readyState === 'loading') {
      listen(document, 'DOMContentLoaded', boot);
    } else {
      boot();
    }


      listen(sectionRoot, 'shopify:block:select', function(event) {
        if (event.detail && event.detail.blockId === config.modalBlockId && BADGE_ENABLED) openChoiceModal();
      });
    }
    disconnectedCallback() {
      (this.cleanups || []).forEach(cleanup => cleanup());
    }
  });
}
